// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3Zhut","buttons":"SendReceipts_buttons__3n-Qd","email":"SendReceipts_email__KnTuB","bookApptTitle":"SendReceipts_bookApptTitle__1ERNw"};